import React, { PureComponent } from 'react'

import { getDisplayDate, getDisplayDateTime, getDisplayTime } from '../../utils/lang'

type Props = {
  data: string
  type?: 'date' | 'dateTime' | 'time'
}

export class OutputDateTime extends PureComponent<Props> {
  render() {
    const { type = 'date', data } = this.props

    if (type === 'date') {
      return <output>{getDisplayDate(data)}</output>
    }

    if (type === 'time') {
      return <output>{getDisplayTime(data)}</output>
    }

    return <output>{getDisplayDateTime(data)}</output>
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/outputs/date-time.tsx